import { Action } from '@ngrx/store';
import { UserLoginMessage } from '@model';

export enum UserLoginMessagesActionTypes {
  LoadUserLoginMessages = '[UserLoginMessages] Load',
  LoadUserLoginMessagesSuccess = '[UserLoginMessages] Load success',
  LoadUserLoginMessagesFail = '[UserLoginMessages] Load fail',

  LoginMessageSetAsRead = '[UserLoginMessages] Set as read',
  LoginMessageSetAsReadSuccess = '[UserLoginMessages] Set as read success',
  LoginMessageSetAsReadFail = '[UserLoginMessages] Set as read fail'
}

export class LoadUserLoginMessages implements Action {
  readonly type = UserLoginMessagesActionTypes.LoadUserLoginMessages;
  constructor() {}
}

export class LoadUserLoginMessagesSuccess implements Action {
  readonly type = UserLoginMessagesActionTypes.LoadUserLoginMessagesSuccess;
  constructor(public payload: UserLoginMessage[]) {}
}

export class LoadUserLoginMessagesFail implements Action {
  readonly type = UserLoginMessagesActionTypes.LoadUserLoginMessagesFail;
  constructor(public payload: any) {}
}

export class LoginMessageSetAsRead implements Action {
  readonly type = UserLoginMessagesActionTypes.LoginMessageSetAsRead;
  constructor(public payload: number) {}
}

export class LoginMessageSetAsReadSuccess implements Action {
  readonly type = UserLoginMessagesActionTypes.LoginMessageSetAsReadSuccess;
  constructor(public payload: UserLoginMessage) {}
}

export class LoginMessageSetAsReadFail implements Action {
  readonly type = UserLoginMessagesActionTypes.LoginMessageSetAsReadFail;
  constructor(public payload: any) {}
}

export type UserLoginMessagesActions =
  | LoadUserLoginMessages
  | LoadUserLoginMessagesSuccess
  | LoadUserLoginMessagesFail
  | LoginMessageSetAsRead
  | LoginMessageSetAsReadSuccess
  | LoginMessageSetAsReadFail;
